/**
 * /frontend/src/features/analytics/components/queue/QueueOutcomePieChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import DistributionPieChart from '../charts/DistributionPieChart';
import { toOutcomePieSeries } from '../../utils/chartDataTransformers';

/**
 * Queue outcome distribution pie chart.
 * @param {{performance:any}} props
 * @returns {JSX.Element}
 */
const QueueOutcomePieChart = ({ performance }) => {
  const data = useMemo(() => toOutcomePieSeries(performance), [performance]);
  return (
    <ChartContainer title="Outcome Distribution" subtitle="Completed vs abandoned vs other outcomes">
      <DistributionPieChart data={data} nameKey="name" valueKey="value" />
    </ChartContainer>
  );
};

export default QueueOutcomePieChart;

